import { ContactFormFields } from '@spa/components/contact/contactFormTypes';
import { SubmitContactFormResult } from '../../../graphql/transactional-email/submitContactForm';
import { WithHoneypot } from '@spa/components/forms/formik-with-honey/formikWithHoney.component';
import { createAction } from '@reduxjs/toolkit';

export const apiContactFormSubmitRequested = createAction<{
  actionId: number;
  formData: WithHoneypot<ContactFormFields>;
  parentActionId: number;
  honeypotToken: string;
}>('api/contact/submitFormRequested');

export const apiContactFormSubmitSucceeded = createAction<{
  requestedActionId: number;
  result: SubmitContactFormResult;
}>('api/contact/submitFormSucceeded');

export const apiContactFormSubmitFailed = createAction<{
  requestedActionId: number;
  error: Error;
}>('api/contact/submitFormFailed');
